import { Layout } from './Layout';
import { useAuth } from '../lib/auth';
import { navigate } from '../lib/router';

export type AdminTab = 'sites' | 'users' | 'affiliates' | 'plans' | 'commissions' | 'emails';

const TABS: { key: AdminTab; label: string; href: string }[] = [
  { key: 'sites',       label: 'Sites',           href: '/admin' },
  { key: 'users',       label: 'Users',           href: '/admin/users' },
  { key: 'affiliates',  label: 'Affiliates',      href: '/admin/affiliates' },
  { key: 'plans',       label: 'Plans',           href: '/admin/plans' },
  { key: 'commissions', label: 'Commissions',     href: '/admin/commissions' },
  { key: 'emails',      label: 'Email Templates', href: '/admin/emails' },
];

export function AdminShell({ active, children }: { active: AdminTab; children?: any }) {
  const { user, loading } = useAuth();
  if (loading) return <Layout active="admin"><div class="py-16 text-center text-slate-400">Loading…</div></Layout>;
  if (!user?.isAdmin) {
    return (
      <Layout active="admin">
        <div class="text-center py-16 text-slate-400">Admin access required.</div>
      </Layout>
    );
  }

  return (
    <Layout active="admin">
      <div class="mb-6">
        <h1 class="text-2xl font-bold text-slate-100">Admin</h1>
        <p class="text-slate-400 mt-1">Manage sites, affiliates, plans, commissions and emails.</p>
      </div>
      <nav class="flex gap-1 border-b border-slate-700/50 mb-6 overflow-x-auto">
        {TABS.map((t) => (
          <a
            href={t.href}
            onClick={(e: MouseEvent) => { e.preventDefault(); navigate(t.href); }}
            class={`px-4 py-2.5 text-sm font-medium whitespace-nowrap border-b-2 transition-colors ${
              active === t.key ? 'border-cyan-400 text-cyan-400' : 'border-transparent text-slate-400 hover:text-slate-200'
            }`}
          >{t.label}</a>
        ))}
      </nav>
      {children}
    </Layout>
  );
}
